﻿$.fn.dxCtrlSondageQuestionOuiNonConsolide = function custom_dxCtrlSondageQuestionOuiNonConsolide(option) {
    if (option == "instance") {
        return this.instance;
    }
    else {
        this.addClass("dx-dxctrlsondagequestionouinonconsolide dx-ctrl");
        this.createInstance(new cdxCtrlSondageQuestionOuiNonConsolide(this, option));
    }
    return this;
}
window.cdxCtrlSondageQuestionOuiNonConsolide = function (container, option) {
    var Me = this;
    // Palette par défaut : Oui en bleu, Non en rouge (ordre fixe)
    var PALETTE_DEFAUT = ["#2a78d6", "#e34948"];
    var COULEUR_FOND = "#e1e0d9";
    var BADGE = { txt: "Oui / Non", bg: "#eaf1fb", color: "#2a78d6" };
    this.option = function (name, value) {
        if (typeof value == 'undefined') {
            return option[name];
        }
        else {
            option[name] = value;
            dx.option(name, value);
        }
    }
    var dx = null;
    function mFormateNombre(n) {
        return n.toLocaleString("fr-FR");
    }
    function mFormateReponses(n) {
        return mFormateNombre(n) + (n > 1 ? " réponses" : " réponse");
    }
    function mConstruit() {
        container.empty();
        var dataSource = option.dataSource || [];
        var palette = option.palette || PALETTE_DEFAUT;
        var question = option.question || {};
        var total = option.nb_repondant;
        // ---- En-tête : titre de la question, sous-titre, badge ----
        var titre = $("<div>").html(option.question.text_intro || "").text();
        var $titre = $("<h3>").text(titre).css({
            fontSize: "14px",
            fontWeight: "600",
            margin: "0 0 5px",
            color: "#0b0b0b"
        });
        var $sousTitre = $("<div>").text(mFormateReponses(total)).css({
            fontSize: "12.5px",
            color: "#898781"
        });
        var $titres = $("<div>").css({
            display: "flex",
            flexDirection: "column",
            gap: "5px",
            minWidth: "0"
        }).append($titre, $sousTitre);
        var $badge = $("<span>").text(BADGE.txt).css({
            flex: "none",
            fontSize: "11px",
            fontWeight: "700",
            padding: "4px 10px",
            borderRadius: "999px",
            whiteSpace: "nowrap",
            background: BADGE.bg,
            color: BADGE.color
        });
        var $entete = $("<div>").css({
            display: "flex",
            alignItems: "flex-start",
            justifyContent: "space-between",
            gap: "12px",
            marginBottom: "14px"
        }).append($titres, $badge);
        container.append($entete);
        if (dataSource.length === 0) {
            container.append(
                $("<div>").text("Aucune donnée à afficher.").css({
                    fontSize: "13px",
                    color: "#898781",
                    fontStyle: "italic"
                })
            );
            return;
        }
        // ---- Barre à segments (Oui / Non) rendue avec dxLinearGauge ----
        var hauteur = option.height || 38;
        // Calcule les segments cumulés (startValue/endValue en %) + comble le reste
        // avec la couleur de fond neutre si les pourcentages ne totalisent pas 100.
        var ranges = [];
        var start = 0;
        dataSource.forEach(function (item, index) {
            var nb = item.nb || 0;
            var pct = total > 0 ? (nb / total * 100) : 0;
            var couleur = palette[index % palette.length];
            if (pct > 0) {
                ranges.push({
                    startValue: start,
                    endValue: start + pct,
                    color: couleur,
                    _pct: pct,
                    _mid: start + pct / 2,
                    _label: Math.round(pct) + " %"
                });
                start += pct;
            }
        });
        if (start < 100) {
            ranges.push({ startValue: start, endValue: 100, color: COULEUR_FOND });
        }
        var $gaugeWrap = $("<div>").css({
            position: "relative",
            height: hauteur + "px",
            borderRadius: "8px",
            overflow: "hidden",
            background: COULEUR_FOND
        });
        var $gaugeHost = $("<div>").appendTo($gaugeWrap);
        container.append($gaugeWrap);
        window.setTimeout(function () {
            dx = $gaugeHost.dxLinearGauge({
                size: { height: hauteur },
                geometry: { orientation: "horizontal" },
                margin: { top: 0, bottom: 0, left: 0, right: 0 },
                animation: { enabled: false },
                scale: {
                    startValue: 0, endValue: 100,
                    label: { visible: false }, tick: { visible: false }, minorTick: { visible: false }
                },
                // Pas d'animation possible ici de toute façon : rangeContainer.ranges ne
                // s'anime jamais (testé), donc on l'utilise tel quel pour un rendu
                // multi-segments statique (Oui / Non / fond neutre).
                rangeContainer: {
                    backgroundColor: 'none',
                    width: hauteur,
                    offset: 0,
                    ranges: ranges.map(function (r) {
                        return { startValue: r.startValue, endValue: r.endValue, color: r.color };
                    })
                },
                title: { text: '' },
                export: { enabled: false },
                loadingIndicator: { enabled: false },
                tooltip: { enabled: false }
            }).dxLinearGauge("instance");
            // Libellés % en overlay (uniquement si le segment est assez large)
            ranges.forEach(function (r) {
                if (r._pct >= 12) {
                    $("<div>").text(r._label).css({
                        position: "absolute",
                        left: r._mid + "%",
                        top: "50%",
                        transform: "translate(-50%, -50%)",
                        color: "#ffffff",
                        fontSize: "13px",
                        fontWeight: "700",
                        pointerEvents: "none"
                    }).appendTo($gaugeWrap);
                }
            });
        }, 0);
        // ---- Légende ----
        var $legende = $("<div>").css({
            display: "flex",
            gap: "20px",
            marginTop: "10px",
            fontSize: "12.5px",
            color: "#52514e"
        });
        dataSource.forEach(function (item, index) {
            var couleur = palette[index % palette.length];
            var $swatch = $("<span>").css({
                width: "10px",
                height: "10px",
                borderRadius: "3px",
                display: "inline-block",
                background: couleur,
                marginRight: "6px"
            });
            var $item = $("<div>").css({
                display: "flex",
                alignItems: "center"
            }).append($swatch, document.createTextNode(item.txt + " — " + mFormateNombre(item.nb || 0)));
            $legende.append($item);
        });
        container.append($legende);
    }
    this.element = function () { return container; }
    this.component = function () { return dx; }
    mConstruit();
}

//$.fn.dxCtrlSondageQuestionOuiNonConsolide = function custom_dxCtrlSondageQuestionOuiNonConsolide(option) {
//    if (option == "instance") {
//        return this.instance;
//    }
//    else {
//        this.addClass("dx-dxctrlsondagequestionouinonconsolide dx-ctrl");
//        this.createInstance(new cdxCtrlSondageQuestionOuiNonConsolide(this, option));
//    }
//    return this;
//}

//window.cdxCtrlSondageQuestionOuiNonConsolide = function (container, option) {
//    var Me = this;

//    // Palette par défaut : Oui en bleu, Non en rouge (ordre fixe)
//    var PALETTE_DEFAUT = ["#2a78d6", "#e34948"];

//    var BADGE = { txt: "Oui / Non", bg: "#eaf1fb", color: "#2a78d6" };

//    this.option = function (name, value) {
//        if (typeof value == 'undefined') {
//            return option[name];
//        }
//        else {
//            option[name] = value;
//            dx.option(name, value);
//        }
//    }

//    function mFormateNombre(n) {
//        return n.toLocaleString("fr-FR");
//    }
//    function mFormateReponses(n) {
//        return mFormateNombre(n) + (n > 1 ? " réponses" : " réponse");
//    }

//    function mConstruit() {
//        container.empty();

//        var dataSource = option.dataSource || [];
//        var palette = option.palette || PALETTE_DEFAUT;
//        var question = option.question || {};
//        var total = option.nb_repondant;

//        // ---- En-tête : titre de la question, sous-titre, badge ----
//        var titre = $("<div>").html(option.question.text_intro || "").text();
//        var $titre = $("<h3>").text(titre).css({
//            fontSize: "14px",
//            fontWeight: "600",
//            margin: "0 0 5px",
//            color: "#0b0b0b"
//        });

//        var $sousTitre = $("<div>").text(mFormateReponses(total)).css({
//            fontSize: "12.5px",
//            color: "#898781"
//        });

//        var $titres = $("<div>").css({
//            display: "flex",
//            flexDirection: "column",
//            gap: "5px",
//            minWidth: "0"
//        }).append($titre, $sousTitre);

//        var $badge = $("<span>").text(BADGE.txt).css({
//            flex: "none",
//            fontSize: "11px",
//            fontWeight: "700",
//            padding: "4px 10px",
//            borderRadius: "999px",
//            whiteSpace: "nowrap",
//            background: BADGE.bg,
//            color: BADGE.color
//        });

//        var $entete = $("<div>").css({
//            display: "flex",
//            alignItems: "flex-start",
//            justifyContent: "space-between",
//            gap: "12px",
//            marginBottom: "14px"
//        }).append($titres, $badge);

//        container.append($entete);

//        if (dataSource.length === 0) {
//            container.append(
//                $("<div>").text("Aucune donnée à afficher.").css({
//                    fontSize: "13px",
//                    color: "#898781",
//                    fontStyle: "italic"
//                })
//            );
//            return;
//        }

//        // ---- Barre à deux segments (Oui / Non) ----
//        var $track = $("<div>").css({
//            display: "flex",
//            height: "38px",
//            borderRadius: "8px",
//            overflow: "hidden",
//            background: "#e1e0d9"
//        });

//        dataSource.forEach(function (item, index) {
//            var nb = item.nb || 0;
//            var pct = total > 0 ? (nb / total * 100) : 0;
//            var couleur = palette[index % palette.length];

//            var $seg = $("<div>").css({
//                width: Math.max(pct, pct > 0 ? 0.6 : 0) + "%",
//                background: couleur,
//                display: "flex",
//                alignItems: "center",
//                justifyContent: "center",
//                color: "#ffffff",
//                fontSize: "13px",
//                fontWeight: "700"
//            });

//            // le libellé n'est affiché que si le segment est assez large
//            if (pct >= 12) {
//                $seg.text(Math.round(pct) + " %");
//            }

//            $track.append($seg);
//        });

//        container.append($track);

//        // ---- Légende ----
//        var $legende = $("<div>").css({
//            display: "flex",
//            gap: "20px",
//            marginTop: "10px",
//            fontSize: "12.5px",
//            color: "#52514e"
//        });

//        dataSource.forEach(function (item, index) {
//            var couleur = palette[index % palette.length];

//            var $swatch = $("<span>").css({
//                width: "10px",
//                height: "10px",
//                borderRadius: "3px",
//                display: "inline-block",
//                background: couleur,
//                marginRight: "6px"
//            });

//            var $item = $("<div>").css({
//                display: "flex",
//                alignItems: "center"
//            }).append($swatch, document.createTextNode(item.txt + " — " + mFormateNombre(item.nb || 0)));

//            $legende.append($item);
//        });

//        container.append($legende);
//    }

//    this.element = function () { return container; }
//    this.component = function () { return Me; }

//    mConstruit();
//}